export default __webpack_public_path__ + "static/media/fullscreen.dbe54a96.svg";